import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
// import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroller';

import { APP_ROOT_URL } from '../../../actions/urlTypes';

import { impersonatUser } from '../../../actions/loginActions';
import ImpersonateIcon from '../shared/ImpersonateIcon';

const UsersTable = ({ users, pageStart, loadMore, hasMore, onSort, sortOrder }) => {
  const sortOrderVal = sortOrder === 'asc' ? 'desc' : 'asc';
  return (
    <div className="table-wrapper">
      <div className="table-head">
        <table>
          <thead>
            <tr className="table-row table-row-head">
              <th className="table-cell table-cell-name">
                <button
                  className={`buttonSort buttonSort_${sortOrder}`}
                  onClick={() => onSort('firstName', sortOrderVal)}
                >
                  Name
                </button>
              </th>
              <th className="table-cell table-cell-email">
                <button
                  className={`buttonSort buttonSort_${sortOrder}`}
                  onClick={() => onSort('emailLogin', sortOrderVal)}
                >
                  Email
                </button>
              </th>
              <th className="table-cell table-cell-status">
                <button
                  className={`buttonSort buttonSort_${sortOrder}`}
                  onClick={() => onSort('status', sortOrderVal)}
                >
                  Status
                </button>
              </th>
              <th className="table-cell table-cell-accounts">Accounts</th>
              <th className="table-cell table-cell-date">
                <button
                  className={`buttonSort buttonSort_${sortOrder}`}
                  onClick={() => onSort('lastLoginDate', sortOrderVal)}
                >
                  Last Login
                </button>
              </th>
              <th className="table-cell table-cell-date">
                <button
                  className={`buttonSort buttonSort_${sortOrder}`}
                  onClick={() => onSort('creationDate', sortOrderVal)}
                >
                  Created Date
                </button>
              </th>
              <th className="table-cell table-cell-date">
                <button
                  className={`buttonSort buttonSort_${sortOrder}`}
                  onClick={() => onSort('updateDate', sortOrderVal)}
                >
                  Last Modified
                </button>
              </th>

              <th className="table-cell table-cell-impersonation">
                <ImpersonateIcon fill="#fff" />
              </th>
            </tr>
          </thead>
        </table>
      </div>

      <div className="table-body">
        <InfiniteScroll
          pageStart={pageStart}
          loadMore={loadMore}
          hasMore={hasMore}
          useWindow={false}
          threshold={10}
          loader={<div className="table-loader" key={0}>Loading ...</div>}
        >
          <table>
            <tbody>
              {
                users.map((user, i) => {
                  const cantImpersonate = !user.internalAdmin && user.status !== 'DELETED' && user.status !== 'INVITED' && user.status !== 'INACTIVE';
                  let impersonateUser = (
                    <ImpersonateIcon className="icon-impersonation" fill="#b9b9b9" />
                  );

                  if (cantImpersonate) {
                    impersonateUser = (
                      <button title="Impersonate" onClick={() => impersonatUser(user.emailLogin)} className="btn-link">
                        <ImpersonateIcon className="icon-impersonation" />
                      </button>
                    );
                  }

                  return (
                    <tr key={`${user.userId}_${i}`} className="table-row table-row-body">
                      <td className="table-cell table-cell-name" >
                        <Link to={`${APP_ROOT_URL}/admin/users/${user.userId}`} className="table-cell-button">
                          <span className="col-text">{`${user.firstName} ${user.lastName}`}</span>
                        </Link>
                      </td>
                      <td className="table-cell table-cell-email" >
                        <span className="col-text">{user.emailLogin}</span>
                      </td>
                      <td className="table-cell table-cell-status" >
                        <span className="col-text">{user.status ? user.status : '-'}</span>
                      </td>
                      <td className="table-cell table-cell-accounts" >
                        <span className="col-text">{user.accountNames ? user.accountNames : '-'}</span>
                      </td>
                      <td className="table-cell table-cell-date">
                        <span className="col-text">
                          {
                            user.lastLoginDate.trim() ? user.lastLoginDate : '-'
                          }
                        </span>
                      </td>
                      <td className="table-cell table-cell-date" >
                        <span className="col-text">
                          {
                            user.creationDate.trim() ? user.creationDate : '-'
                          }
                        </span>
                      </td>
                      <td className="table-cell table-cell-date">
                        <span className="col-text">
                          {
                            user.updateDate.trim() ? user.updateDate : '-'
                          }
                        </span>
                      </td>
                      <td className="table-cell table-cell-impersonation">
                        {impersonateUser}
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </InfiniteScroll>
      </div>
    </div>
  );
};


UsersTable.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object),
  pageStart: PropTypes.number,
  loadMore: PropTypes.func,
  onSort: PropTypes.func,
  hasMore: PropTypes.bool,
  sortOrder: PropTypes.string,
};

export default UsersTable;
